import {getCookie} from "cookies-next";
// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
// const API_BASE_URL = 'https://vtimetrack.taydocantho.com/api';
const API_BASE_URL = 'https://api-daotao.truonglaitaydo.com/api';
// console.log(process.env.REACT_APP_API_BASE_URL);

async function fetchApiBlob<T>(endpoint: string, options: RequestInit = {}): Promise<Blob> {
    const url = `${API_BASE_URL}${endpoint}`;
    const token = getCookie('auth-token');

    const defaultHeaders: HeadersInit = {};

    if (!(options.body instanceof FormData)) {
        defaultHeaders['Content-Type'] = 'application/json';
    }
    if (token) {
        defaultHeaders['Authorization'] = `${token}`;
    }

    const response = await fetch(url, {
        ...options,
        headers: {
            ...defaultHeaders,
            ...options.headers
        }
    });

    if (!response.ok) {
        var responseException = await response.json();
        if (responseException.responseException && responseException.responseException.exceptionMessage) {
            throw new Error(`${responseException.responseException.exceptionMessage}`);
        }
        if (responseException.message){
            throw new Error(`${responseException.message}`);
        }
        throw new Error(`${response.status}: ${response.statusText}`);
    }

    return await response.blob();
}

export async function fetchApiBlobWithHeaders(endpoint: string, options: RequestInit = {}): Promise<{ blob: Blob; headers: Headers }> {
    const url = `${API_BASE_URL}${endpoint}`;
    const token = getCookie('auth-token');

    const defaultHeaders: HeadersInit = {};

    if (!(options.body instanceof FormData)) {
        defaultHeaders['Content-Type'] = 'application/json';
    }
    if (token) {
        defaultHeaders['Authorization'] = `${token}`;
    }

    const response = await fetch(url, {
        ...options,
        headers: {
            ...defaultHeaders,
            ...options.headers
        }
    });

    if (!response.ok) {
        var responseException = await response.json();
        if (responseException.responseException && responseException.responseException.exceptionMessage) {
            throw new Error(`${responseException.responseException.exceptionMessage}`);
        }
        if (responseException.message){
            throw new Error(`${responseException.message}`);
        }
        throw new Error(`${response.status}: ${response.statusText}`);
    }

    const blob = await response.blob();
    return { blob, headers: response.headers };
}

export default fetchApiBlob;